module.exports = __webpack_public_path__ + "static/FugYep-d787283feff46645b6f4c73086255be2.svg";